import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '@/store';

// isSharedInTeam seeds from EmailMakerImmutableStore at init (useEmailMakerPublishStateInit) and is updated live by the share-in-team popup.
export interface EmailMakerPublishState {
  isSharedInTeam: boolean;
}

const initialState: EmailMakerPublishState = {
  isSharedInTeam: false,
};

const emailMakerPublishStateSlice = createSlice({
  name: 'emailMakerPublishState',
  initialState,
  reducers: {
    setEmailMakerIsSharedInTeam: (state, action: PayloadAction<boolean>) => {
      state.isSharedInTeam = action.payload;
    },
  },
});

export const {setEmailMakerIsSharedInTeam} = emailMakerPublishStateSlice.actions;

export const emailMakerPublishStateReducer = emailMakerPublishStateSlice.reducer;

export const selectEmailMakerIsSharedInTeam = (state: RootState): boolean => state.emailMakerPublishState.isSharedInTeam;
